import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box, Card, makeStyles, Grid, Typography } from "@material-ui/core";
import { scaleRevenuePortalsApps, saveTheWorldApps, powerRevenuePortalsApps, propertiesPortalApps, supplyPortalApps } from "../../pages/home/constants";
import { AppBox } from "../../components/appBox/AppBox";
import { COLORS } from "../../theme/colors";

import { USER_ROLES } from "../../services/constants";
import { selectSystemType } from "../../redux/selectSystem/actions";
import { PAGES } from "../../pages";

const useStyles = makeStyles(() => ({
  navigatorPopup: {
    zIndex: 2,
    right: "50px",
    top: "80px",
    position: "absolute",
    width: "386px",
    height: "554px",
    overflowY: "auto"
  },
}))

const AppCategory = ({
  category
}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cluster } = useSelector((state) => state.selectCSC);

  const handleClick = (item) => {
    if (item.disabled || item.link === "") return;
    if (item.link) {
      window.open(item.link, "_blank");
    }
    else if (item.page) {
      if (item.system_type) dispatch(selectSystemType(item.system_type));
      if (
        item.page === PAGES.workspace.index &&
        cluster.user_role === USER_ROLES.super_pm &&
        !cluster.has_portfolio
      ) {
        navigate(
          `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.portfolioRegistration}`,
        );
      } else {
        navigate(item.page);
      }
    }
  };

  return (
    <Box
      style={{
        borderBottom: `1px solid ${COLORS.greyLight}`
      }}
      sx={{
        minHeight: "162px",
        padding: "20px 28px 20px 28px",
        display: "flex",
        flexDirection: "column",
        gridGap: 10,
      }}>
      <Typography
        style={{
          color: COLORS.purpleGrey,
          fontSize: 12,
          fontWeight: 400,
          marginBottom: 7
        }}
      >{category.title}</Typography>

      <Grid container direction="row" spacing={3}>
        {category.apps.map((each, index) => (
          <Grid item key={index}>
            <AppBox app={each} handleClick={handleClick} hideBar={true} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export const AppsCard = ({
  show
}) => {
  const classes = useStyles();

  return (
    show ? (
      <div>
        <Card className={classes.navigatorPopup}>
          <AppCategory category={scaleRevenuePortalsApps} />
          <AppCategory category={supplyPortalApps} />
          <AppCategory category={powerRevenuePortalsApps} />
          <AppCategory category={propertiesPortalApps} />
          <AppCategory category={saveTheWorldApps} />
        </Card>
      </div>
    ) : null
  );
}